export const mozillaFontAlignFix = '@-moz-document url-prefix()';
